module.exports = function getResource(label) {
    const resources = {
        header: 'Want Free Shipping?',
        message: 'Sign in to get free shipping for this purchase.',
        signInText: 'Sign In'
    };

    return resources[label];
};
